import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { resolvePageTitle } from '@/lib/pageTitles'

const SUFFIX = ' | Ten Four'

export function usePageTitle() {
  const { pathname } = useLocation()

  useEffect(() => {
    const base = resolvePageTitle(pathname)
    document.title = base ? base + SUFFIX : 'Ten Four'
  }, [pathname])
}
